<template>
  <v-layout>
    <div class="padding-container-lg">
      <!-- <v-page-header>
        <span slot="header">
          {{ actionType }} User
        </span>
      </v-page-header> -->
      <div>
        <form @submit.prevent="validateBeforeSubmit">
          <div class="row pb-4">
            <div class="col col-md-6 col-12">
              <div class="form-group">
                <label for="user-first_name">First Name</label>
                <b-form-input
                  v-model="user.first_name"
                  :disabled="disabled"
                  v-validate="'required'"
                  :class="{'danger': errors.has('firstName') }"
                  name="firstName"
                  type="text"
                  placeholder="Enter your first name"
                />
                <!-- <span
                  v-show="errors.has('user first_name')"
                  class="error-text">Required</span> -->
              </div>
            </div>
            <div class="col col-md-6 col-12">
              <div class="form-group">
                <label for="lastName">Last Name</label>
                <b-form-input
                  v-model="user.last_name"
                  :disabled="disabled"
                  v-validate="'required'"
                  :class="{'danger': errors.has('lastName') }"
                  name="lastName"
                  class="col-12"
                  placeholder="Enter your last name"
                />
              </div>
            </div>
            <div class="col col-md-6 col-12 row m-0 p-0">
              <div class="col col-md-6 col-12">
                <div class="form-group">
                  <label for="gender">Gender</label>
                  <b-form-select
                    v-model="user.gender"
                    :disabled="disabled"
                    v-validate="'required'"
                    :class="{'danger': errors.has('gender') }"
                    class="form-control"
                    name="gender"
                    :options="genders"
                  />
                </div>
              </div>
              <div class="col col-md-6 col-12 fl-left">
                <v-date-picker
                  :label="`Date of birth`"
                  :disabled="disabled"
                   :maxDate="getFormattedDate(new Date())"
                  :value="defaultDateFormat(user.dob)"
                  @onChange="(value) => user.dob = value"
                  :className="{'danger': errors.has('dob')}"
                  name="dob"
                  position="bottom"
                />
              </div>
            </div>
            <div class="col col-md-6 col-12">
              <div class="form-group">
                <label for="email">Email</label>
                <b-form-input
                  v-model="user.email"
                  :disabled="disabled"
                  v-validate="'required|email'"
                  :class="{'danger': errors.has('email') }"
                  class="form-control"
                  name="email"
                  placeholder="Enter email"
                />
              </div>
            </div>

            <div class="col col-md-6 col-12">
              <!-- |digits:${10} can be used-->
              <v-mobile-input
                :countryCode="user.country_code"
                :value="user.mobile_no"
                :label="`Mobile Number`"
                :disabled="disabled"
                v-validate="'required'"
                :className="{'danger': errors.has('mobileNumber') }"
                @onChange="onMobileInputChange"
                name="mobileNumber"
                type="number"
                placeholder="Enter MobileNumber"
              />
              <span class="text-danger" v-if="!isMobileNumberValid"><small>The mobileNumber must be a valid mobile number</small></span>
            </div>
            <div class="col col-md-6 col-12">
              <div class="form-group">
                <label for="designation">Designation</label>
                <b-form-select
                  v-model="user.designation"
                  :disabled="true"
                  v-validate="'required'"
                  :class="{'danger': errors.has('designation') }"
                  class="form-control"
                  name="designation"
                  :options="designations"
                />
              </div>
            </div>
            <div class="col col-md-6 col-12">
              <div class="form-group">
                <label>Address</label>
                <textarea
                  class="form-control"
                  placeholder="address"
                  :disabled="disabled"
                  v-validate="'required'"
                  v-model="user.address"
                  :class="{'danger': errors.has('address') }"
                  name="address"
                />
              </div>
            </div>
            <div class="col col-12 text-right">
              <b-button
                v-if="!disabled"
                type="submit"
                variant="primary"
                @click="enableClick"
              >{{ isEdit ? 'Update' : 'Create' }} User
              </b-button>
              <b-button
                v-if="disabled"
                class="float-right"
                variant="primary"
                @click="editUser"
              >
                Edit User
              </b-button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </v-layout>
</template>

<script>
import VLayout from '@/layouts/Default.vue';
import VMobileInput from '@/components/baseComponents/BaseMobileInput.vue';
import { mapGetters } from 'vuex';
import keys from '@/constants/keys';
import roles from '@/constants/_roles';

export default {
  name: 'ModifyUser',
  components: { VLayout, VMobileInput },
  data() {
    return {
      disabled: false,
      resetUser: false,
      isEnableClick: false,
      isEnableEdit: true,
      isMobileNumberValid: true,
      genders: [
        {
          value: null,
          text: 'Select a Gender'
        },
        {
          value: 'male',
          text: 'Male'
        },
        {
          value: 'female',
          text: 'Female'
        }
      ],
      designations: [
        {
          value: null,
          text: 'Select a Role'
        },
        {
          value: roles.CARE_AUTHOR,
          text: 'Care Author'
        },
        {
          value: roles.CARE_NAVIGATOR,
          text: 'Care Navigator'
        },
        {
        value: roles.FIRST_RESPONDER,
        text: 'Initial Call Receiver'
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      user: 'user/getUser',
      organisationId: 'auth/getOrganisationId',
      loading: 'user/getLoading'
    }),
    isEdit() {
      return this.$route.params.id;
    },
    isView() {
      return this.$route.meta.view;
    },
    actionType() {
      // eslint-disable-next-line no-nested-ternary
      return this.isView ? 'View' : this.isEdit ? 'Update' : 'Create';
    }
  },
  watch: {
    isView: {
      handler: 'handleRoute',
      immediate: true
    }
  },
  beforeMount() {
    if (this.$route.params.id) {
      this.$store.dispatch('user/view', this.$route.params.id);
    }
  },
  destroyed() {
    this.$store.dispatch('user/resetUser');
  },
  mounted() {
    this.$eventBus.$on(keys.CONFIRM_ALERT, this.handlePermissions);
  },
  methods: {
    enableClick() {
      this.isEnableClick = true;
      this.isEnableEdit = true;
    },
    validateBeforeSubmit() {
      if (!this.disabled && this.isEnableEdit) {
        this.$validator.validateAll().then((result) => {
          if (result && this.user.mobile_no && this.isMobileNumberValid) {
            this.user.email = this.user.email.toLowerCase();
            const data = this.user;
            data.role = {
              [data.role]: data.role
            };
            data.organisation_id = this.organisationId;
            if (this.isEdit) {
              this.$store.dispatch('user/update', data);
               this.disabled = true
            } else {
              this.$store.dispatch('user/create', data);
            }
          }
        });
      }
    },
    onMobileInputChange({ isValid, country }, mobileNumber) {
      this.isMobileNumberValid = isValid;
      this.user.mobile_no = mobileNumber;
      this.user.country_code = country.dialCode;
    },
    handleRoute(value) {
      this.disabled = Boolean(value);
    },
    editUser() {
      this.isEnableEdit = false;
      this.disabled = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>
